/* eslint-disable import/no-unused-modules */
import { gql } from "@apollo/client";

export const FEATURE_FLAGS_QUERY = gql`
  query feature_flags_query($input: FeatureFlagsInput!) {
    feature_flags(input: $input) {
      name
      enabled
    }
  }
`;
